import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { getServices } from '@/lib/api'
import { formatCurrency } from '@/lib/utils'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

export function Services() {
  const { data: services, isLoading, error } = useQuery({
    queryKey: ['services'],
    queryFn: getServices,
  })

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-muted-foreground">Loading services...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-destructive">Error loading services</div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Services & Plans</h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>All Services</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Service</TableHead>
                <TableHead>Type</TableHead>
                <TableHead className="text-center">Plans</TableHead>
                <TableHead className="text-center">Subscriptions</TableHead>
                <TableHead className="text-right">MRR</TableHead>
                <TableHead className="text-center">Callback</TableHead>
                <TableHead className="text-center">Status</TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {services?.map((service) => (
                <TableRow key={service.id}>
                  <TableCell>
                    <div>
                      <div className="font-medium">{service.name}</div>
                      <div className="text-sm text-muted-foreground">
                        {service.code}
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge variant="outline">
                      {service.billing_type === 'subscription' ? 'Subscription' : 'Credits'}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-center">
                    {service.plan_count}
                  </TableCell>
                  <TableCell className="text-center">
                    {service.subscription_count}
                  </TableCell>
                  <TableCell className="text-right font-medium">
                    {formatCurrency(parseFloat(service.mrr), 'EUR')}
                  </TableCell>
                  <TableCell className="text-center">
                    {service.callback_enabled ? (
                      <Badge variant="default" className="bg-green-500">
                        Enabled
                      </Badge>
                    ) : (
                      <Badge variant="secondary">
                        Disabled
                      </Badge>
                    )}
                  </TableCell>
                  <TableCell className="text-center">
                    {service.is_active ? (
                      <Badge variant="default" className="bg-green-500">
                        Active
                      </Badge>
                    ) : (
                      <Badge variant="destructive">
                        Inactive
                      </Badge>
                    )}
                  </TableCell>
                  <TableCell>
                    <Button variant="ghost" size="sm" asChild>
                      <Link to={`/services/${service.id}`}>
                        View
                      </Link>
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {services?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} className="text-center text-muted-foreground">
                    No services found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  )
}
